import React from "react";
import Logo from "../components/Logo";
import MainContent from "../components/landing_page/MainContent";

export default function LandingPage() {
  return (
    <>
      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center space-x-3">
              {/* Logo */}
              <Logo />
            </div>
          </div>
        </header>

        {/* Main Content - Two Column Grid */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <MainContent />
        </main>
      </div>
    </>
  );
}
